
export const useRedirectData = () => {
  const getRedirects = async () => {        
    const url = `/api/redirects`;
    
    return await useFetch(url, {
      method: 'GET',
    });
  }
  return { getRedirects };
}